const tradeKey = (slug) => `ibigdo.trade.${slug}`;

/** The private trade link a business customer opened this store with (kept in this browser), or null. */
export function tradeToken(slug) {
  try {
    return localStorage.getItem(tradeKey(slug));
  } catch (e) {
    return null;
  }
}

export function saveTradeToken(slug, token) {
  try {
    localStorage.setItem(tradeKey(slug), token);
  } catch (e) {
    // without storage the link still works for this visit only through the address
  }
}

export function clearTradeToken(slug) {
  try {
    localStorage.removeItem(tradeKey(slug));
  } catch (e) {
    // nothing kept
  }
}

const slugOf = (url) => {
  const m = /\/api\/public\/shop\/([^/?]+)/.exec(url);
  return m ? decodeURIComponent(m[1]) : null;
};

/** Requests from a store's public pages: plain fetch, so nothing about a signed-in user goes with a buyer's request (a trade customer's link goes, as a header). */
async function call(url, options) {
  const trade = tradeToken(slugOf(url));
  const r = await fetch(url, { headers: { Accept: 'application/json', ...(trade ? { 'X-Trade-Token': trade } : {}), ...(options?.body ? { 'Content-Type': 'application/json' } : {}) }, ...options });
  const body = await r.json().catch(() => ({}));
  if (!r.ok) {
    const e = new Error(body.message || 'This page could not be opened.');
    e.status = r.status;
    throw e;
  }
  return body;
}

export const getJson = (url) => call(url);
export const postJson = (url, data) => call(url, { method: 'POST', body: JSON.stringify(data) });
